// extracted by mini-css-extract-plugin
module.exports = {"floatingPane":"FloatingPaneOldStyles__floatingPane__0NtxH","cross":"FloatingPaneOldStyles__cross__Z5yLe","title":"FloatingPaneOldStyles__title__vBset"};